<div class="chat-bubble" (click)="_toggleChat()">
    <lg-icon class="chat-bubble__icon--sleep" icon="icon-chat-bot-0"></lg-icon>
    <lg-icon class="chat-bubble__icon--one" icon="icon-chat-bot-1"></lg-icon>
    <lg-icon class="chat-bubble__icon--two" icon="icon-chat-bot"></lg-icon>
</div>
